/**
 * Outcome of a KC activity classified by score:
 * - `CORRECT` when the score reaches the maximum (1).
 * - `INCORRECT` when the score is below 1.
 * - `UNANSWERED` when the activity was not answered (`score === null`).
 */
export const KC_ACTIVITY_OUTCOME = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  UNANSWERED: 'unanswered',
} as const;

export type KcActivityOutcome = (typeof KC_ACTIVITY_OUTCOME)[keyof typeof KC_ACTIVITY_OUTCOME];

/**
 * Outcome shown in the activity detail drawer header tag.
 * Adds the `UNSCORED` state for activities that were responded but not graded
 * (open answers where `score === null`).
 */
export const ACTIVITY_OUTCOME_KIND = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  UNSCORED: 'unscored',
  UNANSWERED: 'unanswered',
} as const;

export type ActivityOutcomeKind = (typeof ACTIVITY_OUTCOME_KIND)[keyof typeof ACTIVITY_OUTCOME_KIND];
